import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { OrderProvider } from "./OrderContext";
import { useAnalytics } from "./analytics";
import { useLang } from "./i18n";
import {
  SelectionPage,
  MenuTypePage,
  CustomMixPage,
  AiPickPage,
  UserFormPage,
  QROrderPage,
  SurveyPage,
  AiPickMenuPage,
  ChatPage,
} from "./pages";

const Shell = () => {
  useAnalytics();
  // Re-render the whole route tree instantly when the language changes.
  useLang();
  return (
    <>
      <Routes>
        <Route path="/" element={<UserFormPage />} />
        <Route path="/menu-type" element={<MenuTypePage />} />
        <Route path="/select" element={<SelectionPage />} />
        <Route path="/custom-mix" element={<CustomMixPage />} />
        <Route path="/ai-pick-menu" element={<AiPickMenuPage />} />
        <Route path="/ai-pick" element={<AiPickPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/qr-order" element={<QROrderPage />} />
        <Route path="/survey" element={<SurveyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <OrderProvider>
      <HashRouter>
        <Shell />
      </HashRouter>
    </OrderProvider>
  );
}

export default App;
